import React, {useState, useEffect} from "react";
import uaeTransactions from "../data/uae/transactions";
import ksaTransactions from "../data/ksa/transactions";
import styled from "styled-components";
import Transaction from "../components/Transaction";
import Code from "../components/Code";
import { Doughnut } from "react-chartjs-2";
import Metrics from "../theme/metrics";
import Attribute from "../components/Attribute";

const Container = styled.div`
  background-color: #fcfcfc;
  padding: 0 24px 24px 24px;
  max-width: 1152px;
  margin: auto;

  h2 {
    margin: 0;
    padding: 16px 0;
    font-size: 16px;
    font-weight: 600;
  }
`;

const ChartWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (min-width: ${Metrics.Breakpoints.medium}) {
    width: 60%;
  }
`;

const Flex = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  padding: 0 0 24px 0;
  margin-bottom: 0px;

  @media screen and (min-width: ${Metrics.Breakpoints.medium}) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Transactions = ({country}) => {
  const [transactions, setTransactions] = useState([])

  // const renderCategory = (dirtyCat) => {
  //   const smallCat = dirtyCat.toLowerCase();
  //   const cleanedCat = smallCat.replaceAll("_", " ");

  //   return cleanedCat;
  // };

  let doughnutData = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [
          "#091553",
          "#081F91",
          "#0080FF",
          "#0546C7",
          "#51B4FB",
          "#9EDBFA",
          "#C2ECFA",
        ],
        hoverBackgroundColor: [
          "#091553",
          "#081F91",
          "#0080FF",
          "#0546C7",
          "#51B4FB",
          "#9EDBFA",
          "#C2ECFA",
        ],
        borderWidth: 0,
      },
    ],
  };

  useEffect(() => {
    if (country !== "SAU") {
      setTransactions(uaeTransactions)
    } else {
      setTransactions(ksaTransactions)
    }
  }, [])

  // let doughnutOpts = {
  //   cutout: "80%",
  // };

  // const doughnutLegendOpts = {
  //   display: false,
  //   position: "right",
  //   fullWidth: true,
  //   reverse: false,
  //   labels: {
  //     fontColor: "rgb(255,255,255)",
  //   },
  // };

  transactions.forEach((transaction) => {
    if (doughnutData.labels.includes(transaction.insights.category)) {
    } else {
      doughnutData.labels.push(transaction.insights.category);
      doughnutData.datasets[0].data.push(0);
    }
  });

  doughnutData.labels.forEach((label, index) => {
    transactions.forEach((transaction) => {
      if (transaction.insights.category === label) {
        if (transaction.amount < 0) {
          doughnutData.datasets[0].data[index] += 1;
        }
      }
    });
  });

  const calculateIncome = () => {
    let amount = 0;
    transactions.forEach((transaction) => {
      if (transaction.amount > 0) {
        return amount += transaction.amount;
      }
    });

    return amount;
  };

  const calculateSpend = () => {
    let amount = 0;
    transactions.forEach((transaction) => {
      if (transaction.amount < 0) {
        return amount += transaction.amount;
      }
    });

    return amount;
  };

  return (
    <>
      <Container>
        <h2>Categories</h2>
        <Flex>
          <ChartWrapper>
            <Doughnut
              data={doughnutData}
              options={{
                cutoutPercentage: 70,
                legend: {
                  display: false,
                },
              }}
            />
          </ChartWrapper>
          <div>
            <Attribute
              title="Total Spent"
              value={(calculateSpend() * -1).toLocaleString()}
            />
            <Attribute
              title="Total Income"
              value={calculateIncome().toLocaleString()}
            />
            <Attribute
              title="Disposable Income"
              value={(
                calculateIncome() -
                calculateSpend() * -1
              ).toLocaleString()}
            />
          </div>
        </Flex>
        <h2>Transactions</h2>
        {transactions.map((transaction) => (
          <Transaction
            key={transaction.id}
            amount={transaction.amount}
            merchant={transaction.insights.description_cleansed}
            date={transaction.timestamp}
            category={transaction.insights.category}
          />
        ))}
      </Container>
      <Code code={transactions} />
    </>
  );
};

export default Transactions;
